import React, { useState, useRef, useContext, useEffect } from "react";
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";
import { Link, navigate } from "gatsby";
import CallIcon from "../Icons/CallIcon";
import ThreeDIcon from "../Icons/ThreeDIcon";
import ShedIcon from "../Icons/ShedIcon";
import SearchIcon from "../Icons/SearchIcon";
import CloseIcon from "../Icons/CloseIcon";
import DropArrowIcon from "../Icons/DropArrowIcon";
import SearchCloseIcon from "../Icons/SearchCloseIcon";
import BreakpointDown from "../Media/BreakpointDown";
import BreakpointUp from "../Media/BreakpointUp";
import { Container } from "../Section";

import PortableBuildingsDropdown from "./DropDown/PortableBuildings";
import SteelBuildingsDropdown from "./DropDown/SteelBuildings";
import ResourcesDropdown from "./DropDown/Resources";

import useClickOutside from "../../utils/useClickOutside";

import { Context } from "../../layouts/context";
import { useSearch } from "../../useSearch";

const HeaderWrapper = styled.header`
  position: fixed;
  z-index: 11;
  left: 0;
  right: 0;
  top: 0;
  background-color: #fff;
  z-index: 999;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  height: 60px;
  @media(min-width:1200px){
    height:130px;
  }
`;
const HeaderInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position:relative;
  padding:10px 0;
  height: 60px;
  @media(min-width:1200px){
    height:90px;
  }
`;

const NavBrand = styled(Link)`
  width: 100%;
  overflow:hidden;
  max-width: 90px;
  max-height: 46px;
  @media (min-width: 1200px) {
    max-width: 120px;
    max-height: 56px;
  }
  @media (min-width: 1400px) {
    max-width: 150px;
    max-height: 66px;
  }
`;

const NavbarNav = styled.ul`
  display: flex;
  justify-content: space-around;
  align-items: center;
  list-style: none;
  margin: 0;

  ${BreakpointDown.xl`
    flex-direction:column;
    width:100%;
    flex: auto;
    justify-content: inherit;
  `}
`;
const NavItem = styled.li`
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  @media (min-width: 1200px) {
    width:auto;
  }
  + li {
    border-top: 1px solid #c6c6c6;
    @media (min-width: 1200px) {
      border-top:none;
    }
  }
  .dropdown-menu {
    @media (min-width: 1200px) {
      display: block;
      visibility: hidden;
      opacity: 0;
      transition: all 0.4s cubic-bezier(0.3, 0, 0, 1.3) 0s;
    }
  }


  .nav-link {
    color: #000;
    @media (min-width: 1200px) {
      color: #fff;
    }
    > a {
      font-weight: 500;
      color: #000;
      @media (min-width: 1200px) {
        color: #fff;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .text {
      display: inline-flex;
      + .icon {
        margin-left: 5px;
      }
    }
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      > img {
        margin-bottom: 0;
      }
    }
    .caret {
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease 0s;
      padding: 0;
      transform: rotate(0deg);
      width: 30px;
      height: 30px;
      @media (min-width: 1200px) {
        width: 10px;
        height: 10px;
      }
      > svg {
        width: 15px;
        height: 15px;
        @media (min-width: 1200px) {
          fill: #fff;
          width: 8px;
          height: 8px;
        }
      }
    }
  }

  &:hover,
  &.active {
    .nav-link {
      @media (min-width: 1200px) {
        color: #E43D3C;
        > a {
          color: #E43D3C;
        }
      }
      .caret {
        transform: rotate(180deg);
        > svg {
          @media (min-width: 1200px) {
            fill: #E43D3C;
          }
        }
      }
    }
    .dropdown-menu {
      ${BreakpointUp.xl`
        display: block;
        visibility: visible;
        opacity: 1;
        pointer-events: auto;
        transform: none;
      `}
    }
  }

  &:last-child {
    .dropdown-menu {
      ${BreakpointUp.xl`
        right:0;
        left:auto;
      `}
    }
  }
  &.external-link{
    display: flex;
    @media (min-width: 768px) {
      display: none;
    }
  }
`;

const NavLink = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;  
  padding:5px 0;
  font-size: 16px;
  line-height: 30px;
  font-weight: 500;
  @media (min-width: 1200px) {
    padding: 0 20px;
    line-height: 40px;   
  }
  .text {
    + .caret {
      margin-left: auto;
      @media (min-width: 1200px) {
        margin-left: 5px;
      }
    }
  }
  .caret {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease 0s;
    width: 10px;
    height: 10px;
    padding: 0;
    transform: rotate(0deg);
  }
  .icon {
    align-items: center;
    justify-content: center;
    display: none !important;
    @media (min-width: 1200px) {
      display: flex !important;
    }
  }
`;
const Navbar = styled.div`  
  position:relative;
  width: 100%;
`;
const Nav = styled.nav`
  background-color:#232020;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  .close-menu {
    position: fixed;
    top: 15px;
    right: 15px;
    z-index: 99;
    display: block;
    svg {
      fill: #fff;
      width: 20px;
      height: 15px;
    }
    ${BreakpointUp.xl` 
      display: none;
    `}
    &:hover {
      svg {
        fill: #fff;
      }
    }
  }

  @media (max-width: 1199.98px) {
    padding:0;
    flex-direction: column-reverse;
    width: 0;
    position: fixed;
    top: 60px;
    right: 0;
    height: calc(100vh - 60px);
    z-index: 99;
    transition: all 0.4s cubic-bezier(0.4,0,0.2,1) 0s;
    transform: translate3d(100%,0,0);
    overflow-y: auto;
    display: block;
    background: #EFF3F8;
    z-index: -1;
  }
`;
const TopNav = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: end;
  @media (min-width: 1200px) {
    justify-content: space-around;
  }
`;
const TopNavItem = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    padding: 0 15px;
  }
  @media (min-width: 992px) {
    padding: 0 30px;
  }
  @media (min-width: 1200px) {
    padding: 0 50px;
  }

  &.topnav-item{  
    @media (min-width: 768px) { 
      + .topnav-item{
        &:before{
          content:'';
          position:absolute;
          left:0;
          top:50%;
          transform:translateY(-50%);
          background-color:#B5B5B5;
          width:1px;
          height:100%;    
        }
      }
      &.search, &.hamburger{
        padding:0;
        border-left:none;
        &:before{
          display:none;
        }
      }
    }
  }
  .btn-header{
    display:inline-flex;
    flex-wrap:wrap;
    align-items:center;
    outline:none;
    @media (max-width: 767.98px) {
      padding:0 15px;
    }
    .icon{
      display:flex;
      align-items:center;
      justify-content:center;
      > svg{
        fill:#D7272C;
        width:20px;
        @media (min-width: 992px) {
          width:24px;
        }
        @media (min-width: 1200px) {
          width:auto;
        }
      }
      + .text{
        margin-left:10px;
      }
    }
    .text{
      small{
        display:flex;
        color:#232323;
        font-size:14px;
        line-height:18px;
        @media (min-width: 1200px) {
          font-size:16px;
          line-height:20px;
        }
      }
      strong{
        display:flex;
        font-weight:700;
        color:#232323;
        font-size:16px;
        line-height:20px;
        @media (min-width: 1200px) {
          font-size:18px;
          line-height:24px;
        }
        @media (min-width: 1600px) {
          font-size:22px;
          line-height:30px;
        }
      }
      @media (max-width: 767.98px) {
        display:none;
      }
    }
    &:hover, &:focus{
      .text{
        strong{
          color:#D7272C
        }
      }
    }
  }
  &.search{   
    .btn-search{
      display:flex;
      align-items:center;
      justify-content:center;
      background-color:#232020;
      border-radius:10px;
      width:38px;
      height:38px;
      @media (min-width: 1200px) {
        width:40px;
        height:40px;
      }
      &:hover, &:focus{
        background-color:#D7272C;
      }
      .icon{
        display:flex;
      }
    }
  }
  &.hamburger {
    padding:0;
    border-left:none;
    vertical-align: middle;
    display: flex;
    @media (min-width: 1200px) {
      display: none;
    }
  }
  &.external-link{
    display: none;
    @media (min-width: 768px) {
      display: flex;
    }
  }
`;


const SearchForm = styled.div`
  position: absolute;
  display: none;
  left:10px;
  right: 0;
  z-index: 10;
  &.show {
    display: block;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  input {
    padding: 10px 15px;
  }
  .input-icon {
    > .form-control {
      &::placeholder {
        color: #004485;
      }
      &:focus,
      &:active {
        &::placeholder {
          color: #004485;
        }
      }
      padding: 5px 15px;
      @media (min-width: 1200px) {
        padding: 12px 30px;
      }
    }
    .icon {
      cursor: pointer;
      width: 45px;
      > svg {
        fill: #000;
        width: 15px;
        height: 15px;
      }
      &:hover {
        > svg {
          fill: #D7272C;
        }
      }
    }
    &.right {
      > .form-control {
        padding-right: 45px;
        padding-left: 15px;
      }
    }
  }
`;

const DropSearch = styled.div`
  position: absolute;
  background-color: #fff;
  box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.3);
  width: 298px;
  top: 100%;
  z-index: 2;
  text-align: left;
  overflow-y: auto;
  max-height: 310px;
  border-radius: 8px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: #ebebeb;
  }
  &::-webkit-scrollbar-thumb {
    background: #6d6d6d;
    border-radius: 4px;
  }

  a {
    margin-right: 0;
  }
`;
const DropSearchItem = styled.div`
  cursor: pointer;
  padding: 8px 20px;
  border-bottom: 1px solid rgb(227, 233, 242);
  margin-right: 0 !important;
  & span {
    display: flex;
    align-items: center;
    color: #444;
    font-weight: 500;
    justify-content: space-between;
    padding: 8px 0;
    font-size: 14px;
    line-height: 22px;

    & svg {
      fill: #444;
      transition: transform 0.3s ease-out;
      width: 12px;
      display: none;
      ${BreakpointUp.xl`
				display:block;
			`}
    }
    &:hover {
      color: #000;
      svg {
        transform: translateX(4px);
        fill: #000;
      }
    }
  }
`;


const Header = ({ location, hideSearch }) => {
  const [isMenu, setisMenu] = useState(false);
  const [isDropDown, setDropDown] = useState(false);


  const [currentMenu, setCurrentMenu] = useState("");
  const [searchKey, setSearchKey] = useState(null);
  const [showSearch, setShowSearch] = useState(true);
  const results = useSearch(searchKey);
  const searchInputRef = useRef();
  const targetRef = useRef(null);
  const [showSearchDropDown, setShowSearchDropDown] = useState(false);

  function hangleDropDown(index) {
    if (isDropDown === index) {
      return setDropDown(null);
    }
    setDropDown(index);
  }

  useEffect(() => {
    document.body.classList.toggle("menu-open", isMenu);
  }, [isMenu, setisMenu]);

  const handleClickOutside = (event) => {
    if (targetRef.current && !targetRef.current.contains(event.target)) {
      if (event.target.id !== searchInputRef.current.id) {
        setShowSearchDropDown(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleChange = (e) => {
    setSearchKey(e.target.value);
  };

  const ToggleSearch = () => {
    setShowSearch(!showSearch);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/search-result", { state: { searchKey: searchKey } });
  };

  const steelRef = useRef();
  const portableRef = useRef();
  const resourceRef = useRef();

  // const handleMenu = (menu) => {
  //   if (currentMenu === menu) {
  //     setCurrentMenu("");
  //   } else {
  //     setCurrentMenu(menu);
  //   }
  // };
  //const { setPopupContext } = useContext(Context);
  const handleOutsideClick = () => setCurrentMenu("");
  useClickOutside([portableRef, steelRef, resourceRef], handleOutsideClick);

  return (
    <HeaderWrapper>
      <Container>
        <HeaderInner>
          <NavBrand to="/"><StaticImage src="../../images/logo.png" placeholder="blurred" alt="Buildings And More" /></NavBrand>
          <Navbar>
            <SearchForm className={showSearch ? "search-form" : "search-form show"} >
              <SearchContainer className="search-container">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="input-icon right">
                    <input
                      ref={searchInputRef}
                      className="form-control"
                      type="text"
                      placeholder="Search..."
                      id="search"
                      name="search"
                      autoComplete="off"
                      onChange={(e) => handleChange(e)}
                      onFocus={() => setShowSearchDropDown(true)}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          setShowSearchDropDown(false);
                        }
                      }}
                    />
                    <button
                      type="button"
                      aria-label="Close Search"
                      className="icon"
                      onClick={ToggleSearch}
                    >
                      <SearchCloseIcon />
                    </button>
                  </div>
                </form>
                {showSearchDropDown && (
                  <DropSearch className="drop-search" ref={targetRef}>
                    {results.map((rItem, index) => (
                      <Link to={rItem.url}>
                        <DropSearchItem
                          className="drop-search-item"
                          key={index}
                        >
                          <span>{rItem.name}</span>
                        </DropSearchItem>
                      </Link>
                    ))}
                  </DropSearch>
                )}
              </SearchContainer>
            </SearchForm>
            <TopNav className="topnav">             
              <TopNavItem className="topnav-item">
                <a
                  href="tel:3867556449"
                  aria-label="phone number"
                  className="btn-header"
                >
                  <span className="icon"><CallIcon /></span>
                  <span className="text">
                    <strong>(386) 755-6449</strong>
                    <small>Call Us</small>
                  </span>
                </a>
              </TopNavItem>
              <TopNavItem className="topnav-item external-link">
                <a
                  href="https://bambuildingsheds.senseisheds.com/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="3D Shed Designer"
                  className="btn-header"
                >
                  <span className="icon"><ShedIcon /></span>
                  <span className="text">
                    <strong>3D Shed</strong>
                    <small>Designer</small>
                  </span>
                </a>
              </TopNavItem>
              <TopNavItem className="topnav-item external-link">
                <a
                  
                  href="https://buildingsandmore.sensei3d.com/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="3D Carport Designer"
                  className="btn-header"
                >
                  <span className="icon"><ThreeDIcon /></span>
                  <span className="text">
                    <strong>3D Carport</strong>
                    <small>Designer</small>
                  </span>
                </a>
              </TopNavItem>
              <TopNavItem className="topnav-item search">
                {!hideSearch && (                  
                  <button
                    type="button"
                    aria-label="Search"
                    className="btn-search"
                    onClick={ToggleSearch}
                  >
                    <span className="icon"><SearchIcon /></span>
                  </button>
                )}

              </TopNavItem>
              <TopNavItem className="topnav-item hamburger">
                <button
                  type="button"
                  aria-label="Hamburger Menu"
                  onClick={() => setisMenu(!isMenu)}
                  className="icon"
                >
                  <i className="line icn"></i>
                </button>
              </TopNavItem>
            </TopNav>
          </Navbar>
        </HeaderInner>
      </Container>
      <Nav className="nav">
        <Container>
          <NavbarNav>
            <NavItem>
              <NavLink className="nav-link" onClick={() => hangleDropDown(1)}>                
                <span className="text">Portable Buildings </span>
                <span className="caret">
                  {isDropDown === 1 ? <CloseIcon /> : <DropArrowIcon />}
                </span>
              </NavLink>
              <PortableBuildingsDropdown
                isActive={isDropDown === 1 ? true : false}
              />
            </NavItem>
            <NavItem>
              <NavLink className="nav-link" onClick={() => hangleDropDown(2)}>
                <span className="text">Steel Buildings</span>
                <span className="caret">
                  {isDropDown === 2 ? <CloseIcon /> : <DropArrowIcon />}
                </span>
              </NavLink>
              <SteelBuildingsDropdown
                isActive={isDropDown === 2 ? true : false}
              />
            </NavItem>
            <NavItem><NavLink className="nav-link"><Link to="/red-iron-buildings" className="text">Red Iron Buildings</Link></NavLink></NavItem>
            <NavItem><NavLink className="nav-link"><Link to="/pole-barns" className="text">Pole Barns</Link></NavLink></NavItem>
            <NavItem><NavLink className="nav-link"><Link to="/gazebos" className="text">Gazebos</Link></NavLink></NavItem>
            <NavItem><NavLink className="nav-link"><Link to="/greenhouses" className="text">Greenhouses</Link></NavLink></NavItem>
            <NavItem><NavLink className="nav-link"><Link to="/screen-rooms" className="text">Screen Rooms</Link></NavLink></NavItem>
            <NavItem>
              <NavLink className="nav-link" onClick={() => hangleDropDown(3)}>
                <span className="text">Resources</span>
                <span className="caret">
                  {isDropDown === 3 ? <CloseIcon /> : <DropArrowIcon />}
                </span>
              </NavLink>
              <ResourcesDropdown
                isActive={isDropDown === 3 ? true : false}
              />
            </NavItem>
            <NavItem className="external-link">
              <NavLink className="nav-link">
                <a href="https://engineeredmetalbuildings.sensei3d.com/" target="_blank" rel="noreferrer" aria-label="3D Shed Designer" className="text">3D Shed Designer</a>
              </NavLink>
            </NavItem>
            <NavItem className="external-link">
              <NavLink className="nav-link">
                <a href="https://bambuildingsheds.senseisheds.com/" target="_blank" rel="noreferrer" aria-label="3D Carport Designer" className="text">3D Carport Designer</a>
              </NavLink>
            </NavItem>
          </NavbarNav>
        </Container>
      </Nav>        
    </HeaderWrapper>
  );
};

export default Header;
